module.exports = __webpack_public_path__ + "media/images/games/35gender/swimmer-7906dc8ce1d17f7e76c32f452ba4fe8c.png";